import React, {useState} from "react";
import {Route, Routes,} from "react-router-dom";

import './App.css';
import PeriodSelection from "./components/PaidPeriodInfoForm/PeriodSelection";
import EmployeeEmployerForm from "./components/EmployeeEmployerForm/EmployeeEmployerForm";
import Captcha from "./components/Captcha/Captcha";
import ThankYouPopup from "./components/Custom/ThankYouPopup";

function App() {

    const [employeeId, setEmployeeId] = useState();

  return (
      <>
          <Routes>
              <Route exact path="/" element={<div><Captcha/></div>}/>
              <Route exact path="/employeeForm" element={<div><EmployeeEmployerForm setEmployeeId={setEmployeeId}/></div>}/>
              <Route path="/periodSelection" element={<div><PeriodSelection employeeId={employeeId} /></div>}/>
              <Route path="/thankYouPop" element={<div><ThankYouPopup/></div>}/>
          </Routes>
      </>
  );
}

export default App;
